<div class="outer-container">
   <div class="pageHeader-row">
      <div class="pageHeader-text">
         <div class="heading">DVM Engagement Dashboard</div>
         <div class="subtext">Select a DVM in your region to create a new action plan or view existing.</div>
      </div>

      <div class="pageHeader-filters">
         <!-- DVM Practice -->
         <vc-single-select-dropdown
            class="mr-1"
            [items]="practiceOptions"
            optionLabel="label"
            optionValue="value"
            variantClass="v-sitefilter"
            sizeClass="v-dropdown-md"
            [placeholder]="'Filter by Practice'"
            [filter]="true"
            [setValue]="{ label: selectedPractice, value: selectedPractice }"
            (selectionChange)="onPracticeChange($event)"></vc-single-select-dropdown>

         <!-- DVM Name -->
         <vc-single-select-dropdown
            class="mr-1"
            [items]="dvmNameOptions"
            optionLabel="label"
            optionValue="value"
            variantClass="v-userfilter"
            sizeClass="v-dropdown-sm"
            [placeholder]="'Filter by DVM'"
            [filter]="true"
            [setValue]="{ label: selectedDvmName, value: selectedDvmName }"
            (selectionChange)="onDvmChange($event)"></vc-single-select-dropdown>

         <!-- RM Name -->
         <vc-single-select-dropdown
            [items]="rmNameOptions"
            optionLabel="label"
            optionValue="value"
            variantClass="v-userfilter"
            sizeClass="v-dropdown-sm"
            [placeholder]="'Filter by RM'"
            [filter]="true"
            [setValue]="{ label: selectedRmName, value: selectedRmName }"
            (selectionChange)="onRmChange($event)"></vc-single-select-dropdown>
      </div>
   </div>

   <div class="main-app-container">
      <vc-spinner *ngIf="!isDVMPlansLoaded || !isDVMsLoaded"></vc-spinner>
      <div
         *ngIf="isDVMPlansLoaded && isDVMsLoaded"
         class="table-container">
         <table
            matSort
            (matSortChange)="sortData($event)">
            <thead>
               <tr class="columnHeaders">
                  <th mat-sort-header="name">DVM Name</th>
                  <th mat-sort-header="practice">DVM Practice</th>
                  <th mat-sort-header="lastUpdated">Last Updated</th>
                  <th mat-sort-header="hireDate">Hire Date</th>
                  <th mat-sort-header="rmName">RM Name</th>
                  <th></th>
               </tr>
            </thead>
            <tbody>
               <tr
                  *ngFor="let row of dashboardRows; let i = index"
                  [class.alternate]="i % 2 !== 0"
                  (click)="onRowClick(row)">
                  <td>{{ row.name }}</td>
                  <td>{{ row.practice }}</td>
                  <td [ngClass]="{ 'invalid-date': !isValidDate(row.lastUpdated) }">
                     {{ row.lastUpdatedDisplay }}
                  </td>
                  <td>{{ row.hireDate }}</td>
                  <td>{{ row.rmName }}</td>
                  <td class="width-filler"></td>
               </tr>
            </tbody>
         </table>
      </div>
   </div>
</div>
